export const CONSUMER_LOAN_PURPOSES = [
	"anything",
	"reconstruction",
	"household",
	"car",
] as const;

export const CHILDREN_SAVINGS_REASONS = [
	"startToLife",
	"study",
	"housing",
	"hobbies",
] as const;

export const GOAL_ACHIEVE_REASONS = [
	"car",
	"travelAroundTheWorld",
	"financialReserve",
	"other",
] as const;
